const i18n_fields = {
  EN: [
    { key: 'id', label: 'No.', sortable: true, thStyle: 'width: 5%', option : 1 },
    { key: 'created_at', label: 'DateTime', sortable: true, thStyle: 'width: 50px', option : 0 },
    // { key: 'country', label: 'Country', sortable: true, thStyle: 'width: 4%', option : 0 },
    { key: 'remote_addr', label: 'Attacker', sortable: false, thStyle: 'width: 15%', option : -1 },
    { key: 'agent.nickname', label: 'Nickname', sortable: true, thStyle: 'width: 5%', option : 2 },
    { key: 'target', label: 'Victim', sortable: true, option : -1 },
    { key: 'host', label: 'Host', sortable: false, thStyle: 'width: 5%', option : -1 },
    { key: 'message', label: 'Message', sortable: false, option : 0 },
    { key: 'is_block', label: 'Response', sortable: false, option : 0 },
    { key: 'severity', label: 'Risk', sortable: false, option : -1 },
    { key: 'protocol', label: 'Protocol', sortable: false, option : 3 },
    { key: 'uri', label: 'URI', sortable: false, option : 4 },
    // { key: 'func', label: 'More', sortable: false, thStyle: 'width: 8%', option : -2  },
  ],
  KO : [
    { key: 'id', label: 'No.', sortable: true, thStyle: 'width: 5%', option : 1 },
    { key: 'created_at', label: '탐지시간', sortable: true, thStyle: 'width: 50px', option : 0 },
    // { key: 'country', label: '국가', sortable: true, thStyle: 'width: 4%', option : 0 },
    { key: 'remote_addr', label: '공격자', sortable: false, thStyle: 'width: 15%', option : -1 },
    { key: 'agent.nickname', label: '이름', sortable: true, thStyle: 'width: 5%', option : 2 },
    { key: 'target', label: '공격 대상', sortable: true, option : -1 },
    { key: 'host', label: '호스트', sortable: false, thStyle: 'width: 5%', option : -1 },
    { key: 'message', label: '메세지', sortable: false, option : 0 },
    { key: 'is_block', label: '응답', sortable: false, option : 0 },
    { key: 'severity', label: '위험', sortable: false, option : -1 },
    { key: 'protocol', label: '프로토콜', sortable: false, option : 3 },
    { key: 'uri', label: 'URI', sortable: false, option : 4 },
    // { key: 'func', label: '더 보기', sortable: false, thStyle: 'width: 8%', option : -2  },
  ],
  JP: [
    { key: 'id', label: 'No.', sortable: true, thStyle: 'width: 5%', option : 1 },
    { key: 'created_at', label: '日付/時刻', sortable: true, thStyle: 'width: 50px', option : 0 },
    // { key: 'country', label: '国', sortable: true, thStyle: 'width: 4%', option : 0 },
    { key: 'remote_addr', label: '攻撃者', sortable: false, thStyle: 'width: 15%', option : -1 },
    { key: 'agent.nickname', label: 'ニックネーム', sortable: true, thStyle: 'width: 5%', option : 2 },
    { key: 'target', label: '被害者', sortable: true, option : -1 },
    { key: 'host', label: 'ホスト', sortable: false, thStyle: 'width: 5%', option : -1 },
    { key: 'message', label: 'メッセージ', sortable: false, option : 0 },
    { key: 'is_block', label: '応答', sortable: false, option : 0 },
    { key: 'severity', label: 'リスク', sortable: false, option : -1 },
    { key: 'protocol', label: 'プロトコル', sortable: false, option : 3 },
    { key: 'uri', label: 'URI', sortable: false, option : 4 },
    // { key: 'func', label: 'More', sortable: false, thStyle: 'width: 8%', option : -2  },
  ]
}

const _i18n_warning = {
  range_check : {
    EN: `download range is too long`,
    KO: `download range is too long`,
    JP: `ダウンロードの範囲が長すぎます`
  },
  xff_check : {
    EN: `XFF is not ip format`,
    KO: `XFF is not ip format`,
    JP: `XFF は IP 形式ではありません`
  },
  search_option : {
    EN: `check attacker search option`,
    KO: `check attacker search option`,
    JP: `攻撃者検索オプションをチェックする`
  },
  search_option_2 : {
    EN: `check Victim search option`,
    KO: `check Victim search option`,
    JP: `被害者検索オプションをチェックする`
  },
  search_option_3 : {
    EN: `check uri search option`,
    KO: `check uri search option`,
    JP: `URI検索オプションを確認してください`
  }
}

const _i18n_error = {
  download_failed : {
    EN: `download failed!!`,
    KO: `download failed!!`,
    JP: `ダウンロードに失敗しました!!`
  }
}

const _i18n_data = {
  i18n_fields,
  _i18n_warning,
  _i18n_error
}

export default _i18n_data
